import React, {useMemo} from 'react';
import {connect} from "react-redux";
import {
  END_CAP_CABINETS_PART_IDS,
  SHAPE_PART_ID, SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS, SQFT_FEATURES,
} from "../../../../constants";
import {FormattedMessage} from "react-intl";
import $ from "jquery";
import {addChangeValuePopup, setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import config from "../../../canvas/store/sqftConfig";
import {
  handleResetClick, handleResizeClick, handleRotateClick, handleSpacerClick, handleWallClick,
  resetEvents
} from "../../NavigationHelper";
import useFetchFeatures from "../../../../hocs/useFetchFeatures";
import LoadingSpinner from "../../../../../ui/loadingSpinner";
import {getIsBathroom} from "../../../../../kvComponent/navigation/countertopSwitchers";

const SqftToolMenuCabinet = (props) => {
  // other popups, modals and so on
  const {activeButton, menuOpened, setSQFTActiveButton, setSQFTMenuOpened} = props;
  // const buttonRefs = useRef({});

  let buttons = getIsBathroom()
    ? { ...SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS }
    : { ...SIDEBAR_NAVIGATION_CABINET_BUTTONS };

  const expanded = activeButton
    && menuOpened !== "bumpout"
    && (menuOpened === "move" || Object.keys(buttons).some(buttonKey => menuOpened === buttonKey));
  //this part ids used to remove buttons if there are no features
  const partIds = useMemo(() => [
    SHAPE_PART_ID.tall_cabinet,
    ...END_CAP_CABINETS_PART_IDS,
    SQFT_FEATURES.bottom_handle,
    SQFT_FEATURES.countertop,
    SQFT_FEATURES.hinge
  ], []);
  const { featuresData, isLoading } = useFetchFeatures(partIds);

  // remove buttons without features
  if (!isLoading && featuresData) {
    buttons = Object.keys(buttons).reduce((newButtons, buttonKey) => {
      // remove hinge
      if (!(featuresData.hinge && featuresData.hinge.rows.length > 0)
        && buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge) {
        return newButtons;
      }

      // remove tall cabinet
      if (!(featuresData.tall_cabinet && featuresData.tall_cabinet.rows.length > 0)
        && buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall) {
        if (!featuresData.tall_cabinet.rows.length) {
          console.log("features with 3d models wasn't found for the tall cabinets");
        }
        if (!featuresData.tall_cabinet.featureGroup) {
          console.log("featuregroup tall cabinets wasn't found");
        }

        return newButtons;
      }

      // remove end panel button
      if (
        !(featuresData.wall_door_end_accessory && featuresData.wall_door_end_accessory.rows.length > 0) &&
        !(featuresData.base_door && featuresData.base_door.rows.length > 0) &&
        !(featuresData.island_panel && featuresData.island_panel.rows.length > 0) &&
        !(featuresData.refridgerator_panel && featuresData.refridgerator_panel.rows.length > 0) &&
        buttonKey === SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel
      ) {
        return newButtons;
      }

      newButtons[buttonKey] = buttons[buttonKey];

      return newButtons;
    }, {});
  }

  const handleButtonClick = (buttonKey) => {
    setSQFTMenuOpened(buttonKey);
    setSQFTActiveButton(buttonKey);
    config.workspace.menuItemActive = buttonKey;
    resetEvents();
    switch (buttonKey) {
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.move:
        setSQFTMenuOpened('');
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize);
        handleResizeClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.rotate:
        handleRotateClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer:
        setSQFTMenuOpened('');
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer);
        handleSpacerClick();
        break;
      case SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall:
        setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall);
        handleWallClick();
        break;
      case 'reset':
        handleResetClick();
        break;
    }

    $('.lightbox-option-selected').removeClass('lightbox-option-selected');
  };
  const getTranslationId = (buttonKey) => {
    return "sqft.navigation.submenu." + buttonKey
  }

  return (
    <nav className={"navigation side" + (expanded ? " expanded" : "")} data-side="navigation">
      <div className="navigation-list">
        {isLoading
          ? <LoadingSpinner/>
          : !expanded ? null : Object.keys(buttons).map((buttonKey) => (
            <button key={buttonKey}
                    // ref={el => buttonRefs.current[buttonKey] = el}
                    className={"animated fadeInUp button button--" + buttonKey}
                    onClick={() => handleButtonClick(buttonKey)}>
              <span className="button-text">
                <FormattedMessage id={getTranslationId(buttonKey)}/>
              </span>
            </button>
          ))}
      </div>
    </nav>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton
});

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton,
  addChangeValuePopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftToolMenuCabinet);
